import React, { useState, useEffect } from 'react';

const EditAddressModal = ({ payload, showEditAddressModal, setShowEditAddressModal, address, updateLocation, setSubmitted }) => {
  const [id, setId] = useState(address?.id)
  const [label, setLabel] = useState(address?.label);
  const [firstName, setFirstName] = useState(address?.first_name);
  const [lastName, setLastName] = useState(address?.last_name);
  const [company, setCompany] = useState(address?.company);
  const [street1, setStreet1] = useState(address?.street_1);
  const [street2, setStreet2] = useState(address?.street_2);
  const [city, setCity] = useState(address?.city);
  const [zip, setZip] = useState(address?.zip);
  const [country, setCountry] = useState(address?.country);
  const [state, setState] = useState(address?.state);

  const addressJson = () => {
    return {
      id: id,
      label: label,
      first_name: firstName,
      last_name: lastName,
      company: company,
      street_1: street1,
      street_2: street2,
      city: city,
      zip: zip,
      country: country,
      state: state
    }
  }

  const update = () => {
    updateLocation(payload, addressJson());
    setSubmitted(true);
    setShowEditAddressModal(false);
  }

  const focus = (event) => {
    event.target.parentElement.classList.add("field--focus");
  }

  const blur = (event) => {
    event.target.parentElement.classList.remove("field--focus");
  }

  const setValue = (event, setType) => {
    let value = event.target.value;

    if (value) {
      event.target.parentElement.classList.add("field--filled");
    } else {
      event.target.parentElement.classList.remove("field--filled");
    }
    
    setType(value);
  }

  return(
    <div className="main-overlay">
      <div style={{ top: `${window.innerHeight/2}px` }} className="main-popup popup-center-always main-popup_center main-popup--thin-padding main-popup_animation">
        <div className="main-popup__container">
          <div className="main-popup__close" onClick={() => setShowEditAddressModal(false)}>
            <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M1.7929 1.7929c.3905-.3905 1.0237-.3905 1.4142 0L9 7.5858l5.7929-5.793c.3905-.3904 1.0237-.3904 1.4142 0 .3905.3906.3905 1.0238 0 1.4143L10.4142 9l5.7929 5.7929c.3905.3905.3905 1.0237 0 1.4142-.3905.3905-1.0237.3905-1.4142 0L9 10.4142l-5.7929 5.7929c-.3905.3905-1.0237.3905-1.4142 0-.3905-.3905-.3905-1.0237 0-1.4142L7.5858 9l-5.793-5.7929c-.3904-.3905-.3904-1.0237 0-1.4142z">
              </path>
            </svg>
          </div>
          <div className="main-popup__subcontainer">
            
            <h3>Update Address</h3>

            <div className="fieldset">

              <div className="field field--medium field--filled">
                <span className="fieldset__svg-icon"></span>
                <label className="field__label">Label</label>
                <input type="text" value={label} onFocus={focus} onBlur={blur} onChange={(e) => setValue(e, setLabel)} className="field__input" tabindex="4" maxlength="64" />
                <div className="field__placeholder"></div>
              </div>

              <div className="field field--medium field--filled">
                <span className="fieldset__svg-icon"></span>
                <label className="field__label">firstName</label>
                <input type="text" value={firstName} onFocus={focus} onBlur={blur} onChange={(e) => setValue(e, setFirstName)} className="field__input" tabindex="4" maxlength="64" />
                <div className="field__placeholder"></div>
              </div>

              <div className="field field--medium field--filled">
                <span className="fieldset__svg-icon"></span>
                <label className="field__label">lastName</label>
                <input type="text" value={lastName} onFocus={focus} onBlur={blur} onChange={(e) => setValue(e, setLastName)} className="field__input" tabindex="4" maxlength="64" />
                <div className="field__placeholder"></div>
              </div>

              <div className="field field--medium field--filled">
                <span className="fieldset__svg-icon"></span>
                <label className="field__label">company</label>
                <input type="text" value={company} onFocus={focus} onBlur={blur} onChange={(e) => setValue(e, setCompany)} className="field__input" tabindex="4" maxlength="64" />
                <div className="field__placeholder"></div>
              </div>

              <div className="field field--medium field--filled">
                <span className="fieldset__svg-icon"></span>
                <label className="field__label">street1</label>
                <input type="text" value={street1} onFocus={focus} onBlur={blur} onChange={(e) => setValue(e, setStreet1)} className="field__input" tabindex="4" maxlength="64" />
                <div className="field__placeholder"></div>
              </div>

              <div className="field field--medium field--filled">
                <span className="fieldset__svg-icon"></span>
                <label className="field__label">street2</label>
                <input type="text" value={street2} onFocus={focus} onBlur={blur} onChange={(e) => setValue(e, setStreet2)} className="field__input" tabindex="4" maxlength="64" />
                <div className="field__placeholder"></div>
              </div>

              <div className="field field--medium field--filled">
                <span className="fieldset__svg-icon"></span>
                <label className="field__label">city</label>
                <input type="text" value={city} onFocus={focus} onBlur={blur} onChange={(e) => setValue(e, setCity)} className="field__input" tabindex="4" maxlength="64" />
                <div className="field__placeholder"></div>
              </div>

              <div className="field field--medium field--filled">
                <span className="fieldset__svg-icon"></span>
                <label className="field__label">state</label>
                <input type="text" value={state} onFocus={focus} onBlur={blur} onChange={(e) => setValue(e, setState)} className="field__input" tabindex="4" maxlength="64" />
                <div className="field__placeholder"></div>
              </div>

              <div className="field field--medium field--filled">
                <span className="fieldset__svg-icon"></span>
                <label className="field__label">country</label>
                <input type="text" value={country} onFocus={focus} onBlur={blur} onChange={(e) => setValue(e, setCountry)} className="field__input" tabindex="4" maxlength="64" />
                <div className="field__placeholder"></div>
              </div>

              <div className="field field--medium field--filled">
                <span className="fieldset__svg-icon"></span>
                <label className="field__label">zip</label>
                <input type="text" value={zip} onFocus={focus} onBlur={blur} onChange={(e) => setValue(e, setZip)} className="field__input" tabindex="4" maxlength="64" />
                <div className="field__placeholder"></div>
              </div>

            </div>

            <br/>

            <button className="bottom-5 btn btn-primary btn-medium" onClick={() => update()}>Update Address</button>
          </div>
        </div>
      </div>
    </div>

  )
}

export default EditAddressModal;